import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { records as buildsRecords } from '@saucelabs/sl-module-builds';
import { records as userRecords } from '@saucelabs/sl-module-user';
import { Loader } from '@saucelabs/sl-component-loader';

import { operations, selectors } from './../ducks/flatBuilds';
import Builds from './Builds';
import BuildsEmptyState from './EmptyState/BuildsEmptyState';
import BuildsFilters from './BuildsFilters';
import Styles from './../containers/JobsContainer.styles';

const AutomatedBuildsTab = ({
  builds,
  buildsLoading,
  expandedBuilds,
  failedJobs,
  filtersInitialized,
  handleStopBuild,
  selectOwner,
  toggleBuildCard,
  showOwnersFilter,
  isOpenSauceUser,
  openBadgeConfiguratorModal,
  owners,
  ownership,
  clearStatuses,
  showSeeAllButton,
  status,
  trackedToggleStatus,
  user,
  username,
  noFilters,
}) => (
  <div>
    {filtersInitialized ? (
      <BuildsFilters
        builds={builds}
        clearStatuses={clearStatuses}
        openBadgeConfiguratorModal={openBadgeConfiguratorModal}
        owners={owners}
        ownership={ownership}
        selectOwner={selectOwner}
        showOwnersFilter={showOwnersFilter}
        status={status}
        toggleStatus={trackedToggleStatus}
        user={user}
      />
    ) : null}
    <Loader
      className={Styles.loader}
      fontSize={3}
      show={buildsLoading}
    >
      {builds.size === 0 && noFilters ? <BuildsEmptyState /> : (
        <Builds
          builds={builds}
          currentUser={user.get('username')}
          expandedBuilds={expandedBuilds}
          failedJobs={failedJobs}
          handleStopBuild={handleStopBuild}
          isOpenSauceUser={isOpenSauceUser}
          onToggle={(payload) => {
            toggleBuildCard({ ...payload, username });
          }}
          showSeeAllButton={showSeeAllButton}
        />
      )}
    </Loader>
  </div>
);

const mapDispatchToProps = {
  openBadgeConfiguratorModal: operations.openBadgeConfiguratorModal,
  toggleBuildCard: operations.toggleCard,
  handleStopBuild: operations.stopBuild,
};

AutomatedBuildsTab.propTypes = {
  builds: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(buildsRecords.BuildRecordClass).isRequired,
  ).isRequired,
  buildsLoading: PropTypes.bool.isRequired,
  clearStatuses: PropTypes.func.isRequired,
  expandedBuilds: ImmutablePropTypes.list.isRequired,
  failedJobs: ImmutablePropTypes.mapOf(
    PropTypes.arrayOf(ImmutablePropTypes.record).isRequired,
    PropTypes.string.isRequired,
  ).isRequired,
  filtersInitialized: PropTypes.bool.isRequired,
  handleStopBuild: PropTypes.func.isRequired,
  isOpenSauceUser: PropTypes.bool.isRequired,
  noFilters: PropTypes.bool.isRequired,
  openBadgeConfiguratorModal: PropTypes.func.isRequired,
  owners: PropTypes.array.isRequired,
  ownership: PropTypes.object.isRequired,
  selectOwner: PropTypes.func.isRequired,
  showOwnersFilter: PropTypes.bool.isRequired,
  showSeeAllButton: PropTypes.bool.isRequired,
  status: ImmutablePropTypes.list.isRequired,
  toggleBuildCard: PropTypes.func.isRequired,
  trackedToggleStatus: PropTypes.func.isRequired,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass).isRequired,
  username: PropTypes.string.isRequired,
};

export default connect(
  selectors.automatedBuildsSelector,
  mapDispatchToProps,
)(AutomatedBuildsTab);
export {
  AutomatedBuildsTab,
};
